import { render, staticRenderFns } from "./bottomLeftChart.vue?vue&type=template&id=5b6a66b4&scoped=true&"
import script from "./bottomLeftChart.vue?vue&type=script&lang=js&"
export * from "./bottomLeftChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6a66b4",
  null
  
)

export default component.exports